import { AuthLocaleTypes } from '../locales.types'

const authLocaleNb: AuthLocaleTypes = {
  login: 'Logg inn',
  logout: 'Logg ut',
  signup: 'Registrer deg',
  signout: 'Logg ut',
  withFeide: 'Logg inn utan Feide',
  email: 'E-post',
  emailPlaceholder: 'eksempel@epost.com',
  password: 'Passord'
}

export default authLocaleNb
